import React from 'react';
import { Link } from 'react-router-dom';
import { Space } from 'antd';

import CustomButton from '../../../../components/CustomButton';
import SpinLoad from '../../../../components/SpinLoad';
import INTERNAL_LINKS from '../../../../enums/InternalLinks';
import Paragraph from 'antd/lib/typography/Paragraph';
import AjaxTable from '../../../../components/AjaxTable';
import { ajaxTable as filterAjaxTable } from '../../../../api/module/announcement_selection';

const AjustarInformacion = ({
  dataSource,
  announcement_id,
  announcement_data,
  announcement_rol_id,
  loading,
  showHistory = () => {},
  historyLoading = false,
}) => {
  const columns = [
    {
      title: 'Correo electrónico',
      dataIndex: ['tercero_data', 'notificacion_email'],
      key: ['tercero_data', 'notificacion_email'],
      align: 'center',
    },
    {
      title: 'Nombres y Apellidos',
      dataIndex: ['tercero_data', 'nombre_completo'],
      key: ['tercero_data', 'nombre_completo'],
      align: 'center',
    },
    {
      title: 'Tipo Identificación',
      dataIndex: ['tercero_data', 'tipo_identificacion_nombre'],
      key: ['tercero_data', 'tipo_identificacion_nombre'],
      align: 'center',
    },
    {
      title: 'Doc Identificación',
      dataIndex: ['tercero_data', 'numero_identificacion'],
      key: ['tercero_data', 'numero_identificacion'],
    },
    {
      title: 'Educación',
      dataIndex: 'estudio',
      key: 'estudio',
      align: 'center',
      render: (_, record) => {
        if (record.tercero_data.tipo_persona === 1) {
          return (
            <CustomButton
              block
              htmlType={'button'}
              text={
                <Link
                  to={`${INTERNAL_LINKS.ANNOUNCEMENT_SELECTION_VALIDATION_EDUCATION}/${announcement_id}/${record.id}/${record.convocatoria_tercero}/${announcement_rol_id}/${record.tercero}`}
                >
                  Ver
                </Link>
              }
            />
          );
        } else {
          return 'No aplica';
        }
      },
    },
    {
      title: 'Experiencia',
      dataIndex: 'experiencia',
      key: 'experiencia',
      align: 'center',
      render: (_, record) => {
        if (record.tercero_data.tipo_persona === 1) {
          return (
            <CustomButton
              block
              htmlType={'button'}
              text={
                <Link
                  to={`${INTERNAL_LINKS.ANNOUNCEMENT_SELECTION_VALIDATION_LABORAL}/${announcement_id}/${record.id}/${record.convocatoria_tercero}/${announcement_rol_id}/${record.tercero}`}
                >
                  Ver
                </Link>
              }
            />
          );
        } else {
          return 'No aplica';
        }
      },
    },
    {
      title: 'Otras validaciones',
      dataIndex: 'otras_validaciones',
      key: 'otras_validaciones',
      align: 'center',
      render: (_, record) => (
        <CustomButton
          block
          htmlType={'button'}
          text={
            <Link
              to={`${INTERNAL_LINKS.ANNOUNCEMENT_SELECTION_VALIDATION_TESTS}/${announcement_id}/${record.id}/${record.convocatoria_tercero}/${announcement_rol_id}/${record.tercero}`}
            >
              Ver
            </Link>
          }
        />
      ),
    },
    {
      title: 'Listas restrictivas',
      dataIndex: 'otras_validaciones',
      key: 'experiencia',
      align: 'center',
      render: (_, record) => (
        <CustomButton
          block
          htmlType={'button'}
          text={
            <Link
              to={`${INTERNAL_LINKS.ANNOUNCEMENT_SELECTION_VALIDATION_RESTRICTIVE}/${announcement_id}/${record.id}/${record.convocatoria_tercero}/${announcement_rol_id}/${record.tercero}`}
            >
              Ver
            </Link>
          }
        />
      ),
    },
    {
      title: 'Documentos',
      dataIndex: 'documentos',
      key: 'documentos',
      render: (_, record) => {
        if (record.tercero_data.tipo_persona === 2) {
          return (
            <CustomButton
              block
              htmlType={'button'}
              text={
                <Link
                  to={`${INTERNAL_LINKS.ANNOUNCEMENT_SELECTION_VALIDATION_DOCUMENTOS}/${announcement_id}/${record.id}/${record.convocatoria_tercero}/${announcement_rol_id}/${record.tercero}`}
                >
                  Ver
                </Link>
              }
            />
          );
        } else {
          return 'No aplica';
        }
      },
    },
    {
      title: 'Enviar Correo notificación',
      dataIndex: 'estado_preseleccion',
      key: 'estado_preseleccion',
      align: 'center',
      render: (_, record) => (
        <Space>
          <CustomButton
            block
            type="default"
            htmlType={'button'}
            className={'ant-btn-info'}
            text={
              <Link
                to={`${INTERNAL_LINKS.ANNOUNCEMENT_SELECTION_EMAIL}/${announcement_id}/${record.id}/${record.convocatoria_tercero}/${announcement_rol_id}/${record.tercero}?email=adjust-information`}
              >
                Generar correo{' '}
              </Link>
            }
          />
          {record.estado_envio_ajustar && (
            <Paragraph style={{ marginBottom: 0 }}>Enviado</Paragraph>
          )}
        </Space>
      ),
    },
    {
      title: 'Histórico',
      dataIndex: 'id',
      key: 'id',
      render: (_, record) => (
        <CustomButton
          block
          loading={historyLoading}
          type="default"
          onClick={() => {
            showHistory(record);
          }}
          text={'Ver'}
        />
      ),
    },
  ];

  return (
    <SpinLoad loading={loading}>
      {dataSource != null && (
        <AjaxTable
          columns={columns}
          pageSize={10}
          tableTitle={'Listado de contratistas para ajustar información'}
          endpoint={filterAjaxTable}
          searchInput
          exportCSV
          reloadButton
          query={`/?filter[convocatoria_rol]=${announcement_rol_id}&filter[estado_seleccion]=21`}
        />
      )}
    </SpinLoad>
  );
};

export default AjustarInformacion;
